module.exports = __webpack_public_path__ + "static/img/onedown.io.b557f23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/thumbs/onedown.io.jpg
// module id = 39
// module chunks = 1